import React from "react";
import Icon from "../../Icon/Icon";
import {colors} from "../../../utils/styled/_variables.styled";

const LinksAuto = (props) => {
    const { linkArray, selector, colorSelector, hideCurrent } = props; 

  return (
    <>
      {linkArray &&
        linkArray.map((link, i) => {
          if (linkArray.length === i + 1) {
            return (
              <li className={`cmp-breadcrumb__item cmp-breadcrumb__manual ${hideCurrent ? '' : 'cmp-breadcrumb__item--active'} ${colorSelector ? 
                              ' cmp-breadcrumb__white' 
                              : ' cmp-breadcrumb__black'} 
                              `} key={i}>
                {hideCurrent
                ?
                  <a className={`cmp-breadcrumb__item-link ${colorSelector ? ' cmp-breadcrumb__item-link--white' : ' cmp-breadcrumb__item-link--black'}`} href={link.url}>
                  <span>{link.text}</span>
                </a>
                :
                  <span>{link.text}</span>
                }
              </li>
            );
          } else {
            return (
              <li className={`cmp-breadcrumb__item cmp-breadcrumb__manual${colorSelector ? 
                              ' cmp-breadcrumb__white' : ' cmp-breadcrumb__black'}`} key={i}>
                <div className="cmp-breadcrumb__link-container">
                  <a className={`cmp-breadcrumb__item-link ${colorSelector ? ' cmp-breadcrumb__item-link--white' : ' cmp-breadcrumb__item-link--black'}`} href={link.url}>
                    <span>{link.text}</span>
                  </a>
                  < Icon className={`cmp-breadcrumb__arrow ${(i === linkArray.length-2 && hideCurrent) ? '--hidden' : ''} ${(i === linkArray.length - 2) ? 'last__arrow' : ''}`} icon="chevron-right" color={colorSelector ? colors.white : colors.gray3 } />
                </div>
              </li>
            );
          }
        })}
    </>
  );
};

export default LinksAuto;